<template>
    <v-container class="white--text important-links py-10">
       <v-layout row wrap>
           <v-flex xs12 sm4>
                <h4>Důležité odkazy</h4>
               <v-list dense class="transparent" dark>
                   <v-list-item class="pl-0">
                       <v-list-item-title class="grey--text">Obchodní podmínky</v-list-item-title>
                   </v-list-item>
                   <v-list-item  class="pl-0">
                       <v-list-item-title class="grey--text">Ochrana soukromí</v-list-item-title>
                   </v-list-item>
               </v-list>
           </v-flex>
           <v-flex xs12 sm4>
               <h4>Provozovatel</h4>
               <v-list dense class="transparent" dark>
                   <v-list-item class="pl-0">
                       <v-list-item-title class="grey--text">Riwal Group Ltd.,s.r.o.</v-list-item-title>
                   </v-list-item>
                   <v-list-item  class="pl-0">
                       <v-list-item-title class="grey--text">IČ: 25370219</v-list-item-title>
                   </v-list-item>
                   <v-list-item  class="pl-0">
                       <v-list-item-title class="grey--text">Měšická 534, 250 85 Bašť</v-list-item-title>
                   </v-list-item>
               </v-list>
           </v-flex>
           <v-flex xs12 sm4>
               <h4>Sledujte nás</h4>
               <v-icon small color="white">mdi-facebook</v-icon>
           </v-flex>
       </v-layout>
    </v-container>
</template>

<script>
    export default {
        name: 'ImportantLinks'
    }
</script>

<style lang="scss">
    .important-links {
        h4 {
            font-weight: 600;
            text-transform: uppercase;
            font-size: 14px;
        }
    }
</style>
